module.exports = __webpack_public_path__ + "static/media/attraction3.61b9fc94.jpg";